module.exports = __webpack_public_path__ + "fonts/montserrat-latin-400-normal.3515341.woff";